import { dateTimeToMinute } from "@shared/common/utils/luxonHelpers";
import { DateTime } from "luxon";
import { KlusModel } from "../../../../models/KlusModel";
import { calcPosition, calcWidth } from "../../../../utils/TijdlijnDateCalcUtils";
import styles from "./Lopen.module.css";

interface ILopen {
  timeLineBegin: DateTime;
  timeLineEnd: DateTime;
  scale: number;
  klus: KlusModel;
}

export function Lopen({ timeLineBegin, timeLineEnd, scale, klus }: Readonly<ILopen>) {
  const left = calcPosition(klus.beginDatumtijd, timeLineBegin, timeLineEnd, scale);
  const width = calcWidth(klus.beginDatumtijd, klus.eindDatumtijd, timeLineEnd, scale);

  // Indien er met pinttijden gewerkt moet worden kan dateTimeToMinute vervangen worden door dateTimeToMinuteWithPint
  const beginTijd = dateTimeToMinute(klus.beginDatumtijd);
  const eindTijd = dateTimeToMinute(klus.eindDatumtijd);

  return (
    <button
      type="button"
      id={"ScrollableTypes.Klus" + klus.id}
      data-testid={`werklijn-lopen-button-${klus.id}`}
      style={{
        left: left,
        width: width,
      }}
      className={styles["lopen-wrapper"]}
    >
      <div style={{ height: "17px" }}>
        {klus.klusSoort === "LOPEN_FALLBACK" && (
          <tractie-icon
            size="xs"
            name="error-filled"
            color="var(--tractie-color-background-error-default)"
          />
        )}
      </div>
      <div className={styles["lopen-tijd"]}>
        {beginTijd}–{eindTijd}
      </div>
      <div
        data-testid={`werklijn-lopen-balk-${klus.id}`}
        style={{
          width: width,
        }}
        className={styles["lopen-line"] + " " + styles["lopen-line-color"]}
      >
        <div className={styles["lopen-line-color-inner"]} />
      </div>
    </button>
  );
}
